<template>
  <div class="pentagon-status text-center">
    <div
      v-if="loading"
      :aria-label="loadingLabel"
      class="pentagon-status__skeleton"
      role="status"
      aria-busy="true"
    >
      <span
        v-for="line in 5"
        :key="line"
        :style="{ width: lineWidth(line) }"
        class="pentagon-status__line"
      ></span>
    </div>

    <div v-else-if="failed" class="pentagon-status__failed" role="alert">
      <p class="pentagon-status__message">{{ errorMessage }}</p>
      <button class="pentagon-status__retry" type="button" @click="$emit('retry')">
        {{ $t('site.retry') }}
      </button>
    </div>

    <p v-else class="pentagon-status__message">{{ emptyMessage }}</p>
  </div>
</template>

<script>
export default {
  name: 'ContentStatus',
  props: {
    loading: {
      type: Boolean,
      default: false,
    },
    failed: {
      type: Boolean,
      default: false,
    },
    loadingLabel: {
      type: String,
      default: '',
    },
    errorMessage: {
      type: String,
      default: '',
    },
    emptyMessage: {
      type: String,
      default: '',
    },
  },
  methods: {
    // Skeleton lines of varying length, so the placeholder does not look like a table.
    lineWidth(line) {
      return `${40 + ((line * 17) % 45)}%`;
    },
  },
};
</script>

<style scoped>
  .pentagon-status {
    margin: 2.5rem auto;
    max-width: 36rem;
  }

  .pentagon-status__skeleton {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .pentagon-status__line {
    display: block;
    height: 1rem;
    margin: 0.6rem 0;
    border-radius: 2px;
    background: rgba(233, 225, 207, 0.12);
    animation: pentagon-status-pulse 1.6s ease-in-out infinite;
  }

  .pentagon-status__message {
    font-style: italic;
  }

  .pentagon-status__retry {
    min-width: 44px;
    min-height: 44px;
    padding: 0.4rem 1.4rem;
    border: 1px solid var(--pentagon-gold);
    border-radius: 2px;
    background: transparent;
    color: var(--pentagon-gold);
    font-family: var(--pentagon-font-display);
    letter-spacing: 0.1em;
    text-transform: uppercase;
    cursor: pointer;
  }

  .pentagon-status__retry:hover {
    background: var(--pentagon-crimson);
    color: var(--pentagon-ivory);
  }

  @keyframes pentagon-status-pulse {
    50% {
      opacity: 0.45;
    }
  }

  @media (prefers-reduced-motion: reduce) {
    .pentagon-status__line {
      animation: none;
    }
  }
</style>
